import React from "react";

import Spinner from 'react-bootstrap/Spinner';
import Carousel from 'react-bootstrap/Carousel';
import { ChartData } from './Chart';
import Chart from './Chart';
import colors from 'data/colors.json';

import './Chart.css';

interface Props {
    loadData: Function;
    data: ChartData;
    title: string;
    source: string;
    colors: string[];
}

class ChartContainer extends React.Component<Props, { drawChart: boolean[] }> {
    public static defaultProps = {
        colors: colors
    };

    private dataLoaded = false;
    private allDrawn = false;

    constructor(props: Props) {
        super(props);

        this.state = {
            drawChart: new Array<boolean>(0)
        }
    }

    private arrayEquals(arr1: any[], arr2: any[]) {
        if (!arr1 || !arr2)
            return false;

        if (arr1.length !== arr2.length)
            return false;

        for (let i = 0; i < arr1.length; i++) {
            if (arr1[i] !== arr2[i])
                return false;
        }

        return true;
    }

    private setDrawState() {
        const draw = new Array<boolean>(this.props.data.chartSchema.length).fill(false);
        draw[0] = true;
        this.setState({
            drawChart: draw
        });
    }

    componentDidMount() {
        if (!this.props.data) {
            this.props.loadData();
        } else {
            this.setDrawState();
        }
    }

    componentDidUpdate() {
        if (!this.dataLoaded && this.props.data) {
            this.dataLoaded = true;

            this.setDrawState();
        }
    }

    render() {
        if (!this.props.data || this.state.drawChart.length === 0) {
            return (
                <div className="chart-loading-indicator-container">
                    <Spinner className="chart-loading-indicator" animation="border" role="status" style={{ color: this.props.colors[0] }}>
                        <span className="visually-hidden">Loading...</span>
                    </Spinner>
                </div>
            );
        }

        const data = this.props.data;

        //console.log("cc name: ", this.props.data.name);
        //console.log("cc draw: ", this.state.drawChart);

        if (data.chartSchema.length > 1) {
            const handleChange = (index: number) => {
                if(this.allDrawn) {
                    return;
                }

                const draw = new Array<boolean>(...this.state.drawChart);
                draw[index] = true;
                if(draw.reduce((acc, val) => acc && val, true)) {
                    this.allDrawn = true;
                }
                if(!this.arrayEquals(draw, this.state.drawChart)) {
                    this.setState({ drawChart: draw });
                }
            }

            return (
                <Carousel variant="dark" controls={false} interval={null} onSelect={handleChange} slide={false}>
                    {
                        data.chartSchema.map((_, i) => (
                            <Carousel.Item key={i}>
                                <div className="chart-container">
                                    <Chart data={data} title={this.props.title} source={this.props.source} index={i} shown={this.state.drawChart[i]} colors={this.props.colors} />
                                </div>
                            </Carousel.Item>
                        ))
                    }
                </Carousel>
            );
        }

        return (<Chart data={data} title={this.props.title} source={this.props.source} index={0} shown={this.state.drawChart[0]} colors={this.props.colors} />);
    }
}

export default ChartContainer;